import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import AuthShell, { authInput } from "@/pages/AuthShell";
import { Loader2, ShieldAlert } from "lucide-react";

export default function ChangePassword() {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { user, setUser } = useAuth();
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (next !== confirm) { setError("New passwords do not match."); return; }
    setLoading(true);
    try {
      const { data } = await api.post("/auth/change-password", { current_password: current, new_password: next });
      setUser(data.user);
      nav(data.user.role === "admin" ? "/portal/admin" : "/portal");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
      setLoading(false);
    }
  };

  const forced = user && user.must_change_password;

  return (
    <AuthShell eyebrow="Account Security" title={forced ? "Update your password" : "Change password"}>
      {forced && (
        <div style={{ display: "flex", gap: 10, alignItems: "center", background: "#FFDF57", borderRadius: 10, padding: "10px 12px", marginBottom: 16 }}>
          <ShieldAlert size={18} />
          <span style={{ fontSize: 13 }}>For security, you must set a new password before continuing.</span>
        </div>
      )}
      <form onSubmit={submit} style={{ display: "flex", flexDirection: "column", gap: 14 }}>
        <input data-testid="cp-current" type="password" placeholder="Current password" value={current} onChange={(e) => setCurrent(e.target.value)} style={authInput} />
        <input data-testid="cp-new" type="password" placeholder="New password (min 8 chars)" value={next} onChange={(e) => setNext(e.target.value)} style={authInput} />
        <input data-testid="cp-confirm" type="password" placeholder="Confirm new password" value={confirm} onChange={(e) => setConfirm(e.target.value)} style={authInput} />
        {error && <span style={{ color: "#b00020", fontSize: 14 }} data-testid="cp-error">{error}</span>}
        <button className="btn-cobalt" type="submit" disabled={loading} data-testid="cp-submit" style={{ justifyContent: "center" }}>
          {loading ? <Loader2 size={18} className="animate-spin" /> : "Update password"}
        </button>
      </form>
    </AuthShell>
  );
}
